import styles from "./SectionHeader.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import StarRating from "@Components/StarRating";

interface SectionHeaderProps {
  rating?: number;
  reviewCount?: number;
  isDesktop?: boolean;
  t?: any;
}

const SectionHeader = ({ rating, reviewCount, isDesktop, t }: SectionHeaderProps) => {
  const ratingValue = rating ? Number(rating) : 0;
  const isValidRating = !Number.isNaN(ratingValue) && ratingValue > 0;

  return (
    <>
      <span className={styles.title}>{t("Reviews")}</span>
      {/* Mobile: show StarRating inline with header */}
      {!isDesktop && isValidRating && (
        <StarRating
          rating={ratingValue}
          reviewCount={reviewCount}
          className={styles.starRatingPill}
          testId="propertyPage-reviewsSection-starRating-mobile"
        />
      )}
    </>
  );
};

export default wrapperHOC(SectionHeader, {
  componentName: "SectionHeader-ReviewsSection-PropertyPage",
  showForChina: true,
});
